import { Box, Button, Modal, Stack } from '@mui/material'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import EsignStep from './EsignStep'
import { ExamReassignementEsignFormValues } from '@features/qc_task_details_view/schemas/ExamReassignementEsignValidationSchema'

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  borderRadius: 2,
  bgcolor: 'background.default',
  boxShadow: 8,
  padding: 3,
  width: 600,
}

interface EsignModalProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitting: boolean
  methods: UseFormReturn<ExamReassignementEsignFormValues>
}

export default function EsignModal({ open, onClose, onSubmit, isSubmitting, methods }: EsignModalProps) {
  return (
    <Modal open={open} onClick={(e) => e.stopPropagation()}>
      <Box sx={modalStyle}>
        <FormProvider {...methods}>
          <Stack spacing={2} component="form" alignSelf="stretch">
            <EsignStep />
            <Stack justifyContent="space-between" direction="row" alignSelf="stretch" alignItems="center">
              <Button
                variant="contained"
                sx={{ bgcolor: 'secondary.main', color: 'secondary.contrastText' }}
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}
                onClick={onSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Signing...' : 'Sign'}
              </Button>
            </Stack>
          </Stack>
        </FormProvider>
      </Box>
    </Modal>
  )
}
